import { Banner, BlockStack, Text } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface UpgradeBannerProps {
  /** The feature name for i18n keys (e.g., "bundles", "aiChat", "emailCampaigns") */
  feature: string;
  /** The minimum plan name required (e.g., "Growth", "Professional") */
  requiredPlan: string;
}

/**
 * Shows an upgrade banner when the merchant's plan doesn't include a feature.
 * Directs them to the pricing/billing page.
 */
export function UpgradeBanner({ feature, requiredPlan }: UpgradeBannerProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Banner
      title={t('upgrade.title', { plan: requiredPlan })}
      tone="warning"
      action={{
        content: t('upgrade.cta'),
        onAction: () => navigate('/app/pricing'),
      }}
    >
      <BlockStack gap="200">
        <Text as="p" variant="bodyMd">
          {t(`upgrade.features.${feature}`)}
        </Text>
      </BlockStack>
    </Banner>
  );
}
